export default {
    resources: (state) => {
        return state.resources;
    },

    getResourceBySlug: (state, getters) => (slug) => {
        return getters.resources.find((resource) => resource.slug === slug);
    },

    getResourcesByType: (state, getters) => (type) => {
        return getters.resources.filter((resource) => resource.type === type);
    },
};
